import Styled from 'styled-components';


export const DashboardWrapper = Styled.section`
  min-height: 100vh;
  padding-left: 250px !important;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  background-color: var(--sec-color) !important;

  @media screen and (max-width: 580px) {
    padding-top: 5rem !important;
    padding-bottom: 7rem !important;
    padding-left: 0 !important;
  }

.main-container{
background-color: var(--light-color);
padding: 1rem;
border-radius: 10px;
height: 100% !important;
box-shadow: 0px 2px 34px 0px #0000001A;

}
`;

export const StyledIcon = Styled.p`
  color: ${ props => props.color };
  text-align: ${ props => props.right ? 'right' : 'center' };
  font-size: ${ props => props.smallText ? '1.25rem' : `calc(1.375rem + 1.5vw)` };
`;

export const TableContainer = Styled.div`
margin-top: 3rem;
background: linear-gradient(180deg, #001E88 0%, rgba(225, 237, 251, 0) 100%);
border-radius: 16px;
padding: 1rem;
  
`;

export const Button = Styled.button`
margin: 0 !important;
 background: ${ (props) => (
    props.pry ? 'var(--pry-color)'
      : props.sec ? 'var(--sec-color)'
        : props.light ? 'var(--light-color)'
          : props.dark ? 'var(--dark-bold-color)'

            : '') };
color: ${ (props) => (props.pry ? 'var(--light-color)'
    : props.sec ? 'var(--dark-color)'
      : props.light ? 'var(--pry-color)'
        : props.dark ? 'var(--light-color)'
          : '') };

:hover, :focus{
color: ${ (props) => (props.pry ? 'var(--light-color)'
    : props.sec ? 'var(--dark-color)'
      : props.light ? 'var(--pry-color)'
        : props.dark ? 'var(--light-color)'
          : '') };
}
`;

export const Form = Styled.form`

.toggle-eye {
  position: absolute;
 right: 5%;
  top: 5%;
  cursor: pointer;
  font-weight: bolder;
  font-size: 2rem;
}

.toggle-eye svg {
    font-size: 22px !important;
    color: var(--grey-bold-color);
}


}
`;

export const Input = Styled.input`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid var(--grey-bold-color);
  box-sizing: border-box;
  border-radius: 5px !important;
  font-size: 13px;
  line-height: 24px;
  color: var(--dark-color);
  box-shadow: none;
  margin-bottom: 1.5rem !important;
  background-color: var(--light-color);
  
  :hover,:focus{
    border: 1px solid var(--pry-color) !important;
    }
    
    ::placeholder{
        color: var(--grey-bold-color);
    } 
    :disabled{
      background-color: var(--light-bold-color);
    } 
    
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      appearance: none !important;
    }
    `;

export const NameInput = Styled(Input)`
margin-bottom: .5rem !important;

`;

export const Select = Styled.select`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid var(--grey-bold-color);
  box-sizing: border-box;
  border-radius: 5px !important;
  font-size: 13px;
  line-height: 24px;
  color: var(--dark-color);
  box-shadow: none;
  margin-bottom: 1.5rem !important;
  background-color: var(--light-color);
  
  
  :hover,:focus{
      border: 1px solid var(--pry-color) !important;
    }
    
    ::placeholder{
        color: var(--grey-bold-color);
    } 
    
    :disabled{
        background-color: var(--light-bold-color);
    } 

    ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  appearance: none !important;
}
`;

export const Textarea = Styled.textarea`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid var(--grey-bold-color);
  box-sizing: border-box;
  border-radius: 5px !important;
  font-size: 13px;
  line-height: 24px;
  color: var(--dark-color);
  box-shadow: none;
  margin-bottom: 1.5rem !important;
  background-color: var(--light-color);

  
  :hover,:focus{
      border: 1px solid var(--pry-color) !important;
    }
    
    ::placeholder{
        color: var(--grey-bold-color);
    } 
  
    :disabled{
      background-color: var(--light-bold-color);
    } 
`;

export const Label = Styled.label`
margin:0;
/* color: var(--grey-bold-color); */
/* font-size:20px;  */

&>span {
  color: #d10707 !important;
}
`;

export const PasswordInput = Styled(Input)`
padding: 12px 40px 12px 20px; 
`;
export const PinInput = Styled(Input)`
padding: 12px 40px 12px 20px; 
  font-size: 25px;
  font-weight: 600;
  text-align:center;

`;

export const StyledTab = Styled.div`
  background: var(--grey-color);
  display: flex;
  gap: 12px ;
  border-radius: 5px;
  padding: .4rem;
  width: fit-content;
  /* margin-left: auto ; */
  
  
  .links {
    transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
    border-radius: 3px;
    padding:0 .8rem;
    font-size: 14px;
    text-transform:capitalize;
    cursor:pointer;
  }
  .links.active{
    background: var(--light-color);
  }
  `;

export const UserDetail = Styled.p`
font-size:12px;
font-weight: 600;
margin-bottom: 1rem;
`;


export const ErrorPageMain = Styled.main`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: center;
    overflow: hidden;
    color: var(--dark-color);
  `;

export const StyledEmptyData = Styled.div`
  display:flex;
  flex-direction:column;
  gap:10px;
  justify-content: center;
  align-items:center;
  min-height:40vh;

  svg {
    font-size:50px;
  }
`;


export const StyledImgUpload = Styled.div`
        position: relative;
        margin-bottom: 1.5rem;
        border: 1px solid var(--grey-bold-color);
        border-radius: 5px !important;
        padding: .7rem 0;
        margin-top: .5rem;

        input[type="file"] {
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          height:100%;
        }
        
        img {
            width: 100px;
        }
    
        .cancel {
          position:absolute;
          top:0;
          right: 0;
    
          svg {
                font-size: 25px;
                background-color: #ffffff90;
                border-radius: 50%;
                margin:.3rem;
          }
        }

        p {
          margin-bottom:0;
        }
  
        .cover-container{
              position: relative;
              width:100%;
              height:300px;
              img.cover {
                    border-radius: 1rem;
                    width: 100%;
                    height:100%;
                    margin:auto;
                    object-fit:contain;
              }
        }
`;



